// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__138RK","requiredAsterisk":"Info_requiredAsterisk__1ley2"};